export default {"src":"/evde-internet/_next/static/media/location.5a160cbe.svg","height":48,"width":48};